var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.logos.desktop)?_c('img',{attrs:{"src":_vm.logos.desktop}}):_c('UiIcon',{attrs:{"icon":"logoMain","container-size":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }